import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import i18n from '../i18n';

interface SidebarToggleButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

const SidebarToggleButton: React.FC<SidebarToggleButtonProps> = ({ isOpen, onClick }) => {
  const isRTL = i18n.language === 'ar';
  
  return (
    <button
      onClick={onClick}
      className={`
        fixed hidden lg:flex bottom-8 z-20
        items-center justify-center
        w-10 h-10
        bg-gradient-to-br from-neo-primary to-neo-primary/80
        text-white
        rounded-lg
        shadow-md hover:shadow-lg
        transition-all duration-300 ease-in-out
        hover:scale-105
        active:scale-95
        group
        border border-white/10
        ${isOpen 
          ? `${isRTL ? 'right-[260px]' : 'left-[260px]'}` 
          : `${isRTL ? 'right-4' : 'left-4'}`
        }
      `}
      aria-label={isOpen ? 'Hide sidebar' : 'Show sidebar'}
    >
      {/* Icon container */}
      <span className="relative z-10 transition-transform duration-200">
        {isOpen ? (
          isRTL ? (
            <ChevronRightIcon className="w-5 h-5" />
          ) : (
            <ChevronLeftIcon className="w-5 h-5" />
          )
        ) : (
          isRTL ? (
            <ChevronLeftIcon className="w-5 h-5" />
          ) : (
            <ChevronRightIcon className="w-5 h-5" />
          )
        )}
      </span>

      {/* Tooltip */}
      <span className={`
        absolute ${isRTL ? 'right-full mr-3' : 'left-full ml-3'}
        px-3 py-1.5
        bg-gray-900 text-white text-xs font-poppins-500
        rounded-lg
        whitespace-nowrap
        opacity-0 group-hover:opacity-100
        transition-opacity duration-200
        pointer-events-none
        shadow-lg
      `}>
        {isOpen ? 'Hide Menu' : 'Show Menu'}
      </span>
    </button>
  );
};

export default SidebarToggleButton;
